import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";

import SidebarField from "../../../Components/SidebarField";
import Button from "../../../Components/Button";
import TextInput from "../../../Components/TextInput";
import { FormField } from "../../../Components/FormField";
import { Dropdown } from "primereact/dropdown";
import DynamicForm from "../../../Components/Common/DynamicForm/DynamicForm";

const DynamicCategoryForm = ({onClose}) => {
  const [formData, setFormData] = useState([
    { category_name: "", attribute_name: "", description: "", inputType: null, selected_attribute: {} },
  ]);

  const inputTypes = [
    {
      label: "Text",
      type: "text",
      attributes: {
        text: ["title", "pattern"],
        number: ["maxlength", "minlength", "size"],
        boolean: ["required", "readonly", "disabled", "spellcheck"],
      },
    },
    {
      label: "Number",
      type: "number",
      attributes: {
        text: ["title"],
        number: ["value", "min", "max"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Date",
      type: "date",
      attributes: {
        text: ["title"],
        date: ["value", "min", "max"],
        boolean: ["required", "readonly", "disabled", "autofocus"],
      },
    },
    {
      label: "Time",
      type: "time",
      attributes: {
        text: ["title"],
        time: ["value", "min", "max"],
        number: ["step"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Range",
      type: "range",
      attributes: {
        text: ["title"],
        number: ["value", "min", "max", "step"],
        boolean: ["required", "readonly", "disabled"],
      },
    },
    {
      label: "Email",
      type: "email",
      attributes: {
        text: ["title", "pattern"],
        number: ["maxlength", "minlength", "size"],
        boolean: ["required", "readonly", "disabled", "multiple"],
      },
    },
    {
      label: "Boolean",
      type: "checkbox",
      attributes: {
        text: ["title"],
        boolean: ["required", "readonly", "disabled", "checked"],
      },
    },
    {
      label: "Radio",
      type: "radio",
      attributes: {
        text: ["title"],
        boolean: ["required", "readonly", "disabled", "checked"],
      },
    },
    {
      label: "Textarea",
      type: "textarea",
      attributes: {
        text: ["title", "pattern", "wrap"],
        number: ["maxlength", "minlength", "rows", "cols"],
        boolean: ["required", "readonly", "disabled", "spellcheck"],
      },
    },
    {
      label: "Dropdown",
      type: "dropdown",
      attributes: {
        text: ["options"],
        number: [],
        boolean: ["required", "readonly", "disabled", "multiple"],
      },
    },
  ];

  const handleInputChange = (index, field, value) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    setFormData(updatedFormData);
  };

  const addNewSetting = () => {
    setFormData([...formData, { category_name: "", attribute_name: "", description: "", inputType: null, selected_attribute: {} }]);
  };

 
  

  const AttributeOnChange = (index, name, value) => {
    const updatedFormData = [...formData];
    const selectedAttribute = updatedFormData[index].selected_attribute || {};
    selectedAttribute[name] = value;
    updatedFormData[index].selected_attribute = selectedAttribute;
    setFormData(updatedFormData);
  };
  
  const [payload, setPayload] = useState();
  const handleSubmit = (values) => {
    // e.preventDefault();
    console.log("Payload",values);
  };

  const initialValues = {
    category_name: payload?.category_name || "",
    attribute_name: payload?.attribute_name || "",
    description: payload?.description || "",
    inputType: payload?.inputType || "",
    
    selected_attribute:
      payload?.inputType === "text"
        ? {
            title: payload?.selected_attribute?.title || "",
            pattern: payload?.selected_attribute?.pattern || "",
            maxlength: payload?.selected_attribute?.maxlength || "",
            minlength: payload?.selected_attribute?.minlength || "",
            size: payload?.selected_attribute?.size || "",
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
            spellcheck: payload?.selected_attribute?.spellcheck || false,
          }
        : payload?.inputType === "number"
        ? {
            value: payload?.selected_attribute?.value || "",
            min: payload?.selected_attribute?.min || "",
            max: payload?.selected_attribute?.max || "",
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
          }
        : payload?.inputType === "date"
        ? {
            value: payload?.selected_attribute?.value || "",
            min: payload?.selected_attribute?.min || "",
            max: payload?.selected_attribute?.max || "",
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
          }
        : payload?.inputType === "boolean"
        ? {
            checked: payload?.selected_attribute?.checked || false,
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
          }
        : payload?.inputType === "textarea"
        ? {
            title: payload?.selected_attribute?.title || "",
            pattern: payload?.selected_attribute?.pattern || "",
            wrap: payload?.selected_attribute?.wrap || "soft",
            maxlength: payload?.selected_attribute?.maxlength || "",
            minlength: payload?.selected_attribute?.minlength || "",
            rows: payload?.selected_attribute?.rows || "",
            cols: payload?.selected_attribute?.cols || "",
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
            spellcheck: payload?.selected_attribute?.spellcheck || false,
          }
        : payload?.inputType === "dropdown"
        ? {
            options: payload?.selected_attribute?.options || [],
            multiple: payload?.selected_attribute?.multiple || false,
            required: payload?.selected_attribute?.required || false,
            readonly: payload?.selected_attribute?.readonly || false,
            disabled: payload?.selected_attribute?.disabled || false,
          }
        : {}, // Default to an empty object if inputType is not matched
  };
  


  const onEditLabel = (e) => {
    // console.log("Editable Label", e);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        //   validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ handleChange, values, handleSubmit, setFieldValue }) => (
          <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
            <SidebarField
              onClose={onClose}
              title={`Add New Category`}
              button1={
                <Button
                  text="Cancel"
                  type="button"
                     onClick={onClose}
                />
              }
              button2={<Button text={"Add"} />}
            >
              <div className="mx-6 my-6">
                {/* <CommonLayout /> */}
                <div className="flex-col">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <FormField
                      label="Category Name"
                      tooltip="enter your category"
                    >
                      <div className="flex items-center">
                        <TextInput
                          name="category_name"
                          type="text"
                          placeholder="Category"
                          value={values.category_name}
                          onChange={handleChange}
                        />
                      </div>
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error"
                      />
                    </FormField>
                    {formData.map((setting, index) => (
                      <>
                        <div key={index} className="border-primary p1 my-1">
                          
                          <div className="flex-col justify-content-between align-items-center gap-1">
                            <FormField
                              label="Attribute Name"
                              tooltip="enter attribute name"
                            >
                              <div className="flex items-center">
                                <TextInput
                                  name="attribute_name"
                                  type="text"
                                  placeholder="attribute_name"
                                  value={values.attribute_name}
                                  onChange={handleChange}
                                />
                              </div>
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="error"
                              />
                            </FormField>
                            <FormField
                              label="Description"
                              tooltip="enter description here..."
                            >
                              <div className="flex items-center">
                                <TextInput
                                  name="description"
                                  type="text"
                                  placeholder="enter description here..."
                                  value={values.description}
                                  onChange={handleChange}
                                />
                              </div>
                              <ErrorMessage
                                name="description"
                                component="div"
                                className="error"
                              />
                            </FormField>
                            <div className="flex-1">
                              <label
                                className="form-label"
                                htmlFor={`input-type-${index}`}
                              >
                                Input Type
                              </label>
                              <Dropdown
                                value={setting.inputType}
                                options={inputTypes}
                                onChange={(e) =>
                                  handleInputChange(index, "inputType", e.value)
                                }
                                optionLabel="label"
                                placeholder="Select Input Type"
                                style={{
                                  width: "100%",
                                  borderRadius: "5px",
                                  height: "1.9rem",
                                }}
                                className="w-full border"
                                required
                              />
                            </div>
                          </div>
                          {formData[index].inputType !== null ? (
                            <DynamicForm
                              master="true"
                              AttributeOnChange={AttributeOnChange}
                              onEditLabel={(e) => onEditLabel(e)}
                              index={index}
                              inputType={formData[index].inputType}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    ))}
                    <div className="my-1">
                      <button
                        type="button"
                        className="h-6 w-10 rounded-full bg-green-600 text-white"
                        onClick={addNewSetting}
                      >
                        +
                      </button>
                      <button
                        type="button"
                        className="h-6 w-10 rounded-full bg-red-600 text-white"
                        // onClick={removeSetting(index)}
                      >
                        -
                      </button>
                    </div>
                    
                  </form>
                </div>
                <div className="my-2 d-flex gap-1 ">
                  {/* SettingName:{settingsName}
            <br />
            {JSON.stringify(formData)} */}
                  {/* {payload && <SettingComponent settingsHandlechange={settingsHandlechange} settingsName={payload.settingsName} formData={payload.formData} /> } */}
                </div>
              </div>
            </SidebarField>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DynamicCategoryForm; 